'use strict';

const { getDependencyClass } = require('../../lib/dependencies.js');
const performanceMeasure = require('../../lib/performanceMeasure.js');
let measure = performanceMeasure('webcomponents:notifier');

getDependencyClass('phoenix-page').then((pageClass) => {
    /**
     * PhoenixNotifier is a web component responsible for emitting custom events
     * with an assigned event value ('value' optional). By default this component listens
     * to the click event, but single space delimited multiple event names can also be used.
     *
     * @example
     *  <phoenix-notifier
     *      event-name="eventName"
     *      event-value="value">
     *      <button>Do Something</button>
     *  </phoenix-notifier>
     *
     *  <phoenix-notifier
     *      event-name="eventName">
     *      <button>Do Something</button>
     *  </phoenix-notifier>
     *
     *  <phoenix-notifier
     *      event-name="eventName"
     *      events="click scroll touchmove">
     *      <button>Do Something</button>
     *  </phoenix-notifier>
     */

    class PhoenixNotifier extends pageClass.PhoenixElement {
        connectedCallback() {
            this.eventName = this.getAttr('event-name', { required: true });
            this.eventValue = this.getAttr('event-value');
            this.listenEvents = (this.getAttr('events') || 'click').split(' ');
            this._addListener();
        }

        _addListener() {
            this.listenEvents.forEach((e) => {
                this.addEventListener(
                    e,
                    this.notify,
                    pageClass.util.supportPassiveEventListeners() ? { passive: true } : false
                );
            });
        }

        _removeListener() {
            this.listenEvents.forEach((e) => {
                this.removeEventListener(e, this.notify);
            });
        }

        notify() {
            this.emitEvent(this.eventName, {
                bubbles: true,
                detail: {
                    key: this.eventName,
                    value: this.eventValue,
                },
            });
        }

        disconnectedCallback() {
            super.disconnectedCallback();
            this._removeListener();
        }
    }

    window.customElements.define('phoenix-notifier', PhoenixNotifier);
    measure.end();
});
